<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<div>
  <fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
</div>

<div>
  <div id="header-container">
    <h1 class="title">Manage Subregions</h1>
    <button mat-flat-button color="primary" (click)="onAddButtonClick()">Add Subregion</button>
  </div>
  <div class="gfs-table">
    <ag-grid-angular
      style="height: 100%; width:100%;"
      class="ag-theme-quartz"
      [rowData]="subregions"
      [columnDefs]="subregionColumns"
      [autoSizeStrategy]="autoSizeStrategy"
    ></ag-grid-angular>
  </div>
</div>
